import ApiService from '@Utils/apiService'
import * as Path from './apiRoutes'
import { cloneDeep } from 'lodash'
import { 
    ERROR_TITLE,
    ERROR_EMAIL_PREVIEW_MESSAGE,
    FAILED_TO_SAVE_BACKGROUND_CHECK_TITLE,
    FAILED_TO_SAVE_BACKGROUND_CHECK_MESSAGE,
    SEND_SURVEY_LINK_EMAIL_NOTIFICATION_FAILED_TITLE,
    FAILED_TO_SEND_EMAIL_NOTIFICATION_MESSAGE,
 } from '@Utils/constants'
import moment from 'moment'
// Import the action creators
import * as Actions from './actions'

export const getListBackgroundCheck = () => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { backgroundcheckList: { resultTable: { appliedFilter } } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(appliedFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompanyId = auth.credentials.companyId

    ApiService.get(Path.LIST, updateSortModel)
        .then((response) => {
            if (response) {
                const { data } = response
                dispatch(Actions.updateBackgroundCheckList({
                    data: data.items,
                    totalCount: data.count,
                }))
            }
            // return response.data
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false)) 
        })
}

export const createBackgroundCheck = (addModel) => (dispatch, getState) => {
    const { backgroundcheckDetail: { alert } } = getState()
    let nAlert = { ...alert }
    let title = 'Send Survey Link Email Notification Success'
    let message = 'Successfuly sent email notification to character references.'

    if (addModel.IsSave === true) {
        title = 'Background Check Saved Succefully'
        message = 'Successfully saved background check'
    }

    dispatch(Actions.hasDetailLoaded(false))

    return ApiService.post(Path.ROOT, addModel)
        .then((response) => {
            if (response) {
                let goBackToList = true

                if (response.data.returnCode <= 0) {
                    if (addModel.IsSave === true) {
                        title = FAILED_TO_SAVE_BACKGROUND_CHECK_TITLE
                        message = FAILED_TO_SAVE_BACKGROUND_CHECK_MESSAGE
                    } else {
                        title = SEND_SURVEY_LINK_EMAIL_NOTIFICATION_FAILED_TITLE
                        message = FAILED_TO_SEND_EMAIL_NOTIFICATION_MESSAGE
                    }
                    goBackToList = false
                }

                nAlert = {
                    ...nAlert,
                    title: title,
                    show: true,
                    content: message,
                    goBackToListFlag: goBackToList,
                }
                return response.data.returnCode;
            }
        })
        .finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
            dispatch(Actions.updateAddAlertData(nAlert))
        })
}

export const updateBackgroundCheckWithEmail = (detailData, ID, editedTemplate) => (dispatch, getState) => {
    const { backgroundcheckDetail: { alert } } = getState()
    let nAlert = { ...alert }
    let title = 'Send Survey Link Email Notification Success'
    let message = 'Successfuly sent email notification to character references.'

    if (detailData.IsSave === true) {
        title = 'Background Check Saved Succefully'
        message = 'Successfully saved background check'
    }

    dispatch(Actions.hasDetailLoaded(false))

    return ApiService.post(Path.UPDATE_BACKGROUND_CHECK_DETAIL_WITH_EMAIL, {
            id: ID,
            model: detailData,
            editedTemplate: editedTemplate
        })
        .then((response) => {
            if (response) {
                let goBackToList = true

                if (response.data.returnCode <= 0) {
                    if (detailData.IsSave === true) {
                        title = FAILED_TO_SAVE_BACKGROUND_CHECK_TITLE
                        message = FAILED_TO_SAVE_BACKGROUND_CHECK_MESSAGE
                    } else {
                        title = SEND_SURVEY_LINK_EMAIL_NOTIFICATION_FAILED_TITLE
                        message = FAILED_TO_SEND_EMAIL_NOTIFICATION_MESSAGE
                    }
                    goBackToList = false
                }

                nAlert = {
                    ...nAlert,
                    title: title,
                    show: true,
                    content: message,
                    goBackToListFlag: goBackToList,
                }
                return response.data.returnCode;
            }
        })
        .finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
            dispatch(Actions.updateAddAlertData(nAlert))
        })
}

export const getBackgroundCheckById = (id) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    return ApiService.get(Path.ROOT + '/' + id)
        .then((response) => {
            if (response.status === 200) {
                const { data } = response

                if (data.characterReference[0].status != 21) {
                    dispatch(Actions.updateInitialSubmit(false));
                }   

                dispatch(Actions.setBackgroundCheckDetail(convertToViewModel(data)))
                dispatch(Actions.setCharacterReferenceInitialValues(convertToViewModel(data).characterReference))
                dispatch(Actions.setStatusInitialValues(convertToViewModel(data).status))
            } else {
                // TODO: DISPATCH ERROR ALERT FAILED TO LOAD
            }
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}

export const sendEmailNotificationToCharRef = (data) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    return ApiService.get(Path.SEND_EMAIL_NOTIF, {applicantID: data.id, referenceID:data.refid === undefined ? -1 : data.refid, email: data.email})
    .then((response) => {
        if (response) {
            let title = 'Send Survey Link Email Notification Success'
            let message = 'Successfuly sent email notification to character references.'
            let goBackToList = false

            if (response.data.returnCode <= 0) {
                title = 'Send Survey Link Email Notification Failed'
                goBackToList = false
            }

            dispatch(Actions.updateAddAlertData({
                show: true,
                title: title,
                content: message,
                goBackToListFlag: goBackToList,
            }))
        }
    }).catch((error) => {
        console.error(error)
    }).finally(() => {
        dispatch(Actions.hasDetailLoaded(true))
        let res = "Success";
        return res;
    })
}

export const resetSearchResults = () => (dispatch) => {
    // reset filter
    dispatch(Actions.resetResults())
    // Update the list
    dispatch(getListBackgroundCheck())
}

export const updateBackgroundCheck = (detailData) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    const { hrErfDetail: { detailForm } } = getState()
    const { auth } = getState()

    let updateModel = convertToUpdateModel(detailData);

    updateModel.UserId = auth.credentials.userId

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update success',
            content: 'Successfuly updated record.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.put(Path.ROOT + '/' + detailForm.erfID, updateModel)
        .then((response) => {
            if (response) {
                let title = 'Update Success'
                const message = 'Employee Request Form successfully updated.'
                let goBackToList = true
                
                if (response.data.returnCode <= 0) {
                    title = 'Update Failed'
                    goBackToList = false
                }

                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message,
                    confirmLabel: 'Ok',
                    goBackToListFlag: goBackToList,
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}

export const exportBackgroundCheckReport = (filename) => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { backgroundcheckList: { searchFilter } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(searchFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompanyId = auth.credentials.companyId // VERIFIED: change from string to int logged in user data
    updateSortModel.UserID = auth.credentials.userId // VERIFIED: change from string to int logged in user data
    updateSortModel.requestDate = moment.utc(updateSortModel.requestDate).format()

    return ApiService.export(Path.EXPORT, filename, updateSortModel)
        .then((response) => {
            return response
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const fetchBackgroundCheckDetailEmailPreview = (model) => (dispatch) => {
    dispatch(Actions.showLoading(true));
    let convertModel = convertToUpdateModel(model);
    return ApiService.post(Path.GET_BACKGROUND_CHECK_DETAIL_EMAIL_PREVIEW, convertModel)
        .then((response) => {
            if (response && response.data) {
                dispatch(Actions.setDetailEmailTemplate(response.data));
            }
        })
        .catch((error) => {
            dispatch(Actions.updateAddAlertData({
                show: true,
                title: ERROR_TITLE,
                content: ERROR_EMAIL_PREVIEW_MESSAGE,
                goBackToListFlag: false,
            }));
        })
        .finally(() => {
            dispatch(Actions.showLoading(false));
        });
};

//ERF LIST ACTIONS/ACTION OPERATIONS

export const changePage = (newPage) => (dispatch) => {
    // dispatch change filter page
    dispatch(Actions.changeFilterPage(newPage))
    // Update the list
    dispatch(getListBackgroundCheck())
}

export const changeRowsPerPage = (pageModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterRowsPerPage(pageModel))
    // Update list
    dispatch(getListBackgroundCheck())
}

export const changeSort = (sortModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterSort(sortModel))
    // Update list
    dispatch(getListBackgroundCheck())
}

export const applySearchFilters = (searchModel) => (dispatch) => {
    // Page will always be zero upon searching
    dispatch(Actions.changeFilterPage(0))

    // dispatch the search filters
    dispatch(Actions.applyFilters(searchModel))

    // get data from server and update results
    dispatch(getListBackgroundCheck())
}

export const resetFilters = () => (dispatch, getState) => {
    dispatch(Actions.resetFilters())
    return new Promise((resolve, reject) => {
        const { backgroundcheckList: { searchFilter } } = getState()
        resolve(searchFilter)
    })
}

export const convertToUpdateModel = (data) => {
    return {
        BackgroundCheckID: data.id,
        ApplicantID: data.id,
        BackgroundCheckStatus: data.status,
        IsSave: true,
        CharacterReference: data.characterReference.map(ref => ({
            ID: ref.id,
            ApplicantID: ref.applicantID,
            Name: ref.name,
            Email: ref.email,
            UniqueID: ref.uniqueID,
            Remarks: ref.remarks,
            Status: ref.status,
            ExpiryDate: ref.expiryDate,
            DateSubmitted: ref.dateSubmitted,
            DateModified: ref.dateModified
        }))
    }
}

export const convertToViewModel = (data) => {
    return {
        ...data,
    }
}